

export const API_BASE_URL = process.env.API_BASE_URL ||  "https://staging.galaxiinvest.com/api/v1" ||
 "https://api.galaxiinvest.com";

